import { CollectionEntity } from "@busy-human/gearbox";
export var NotarizedDocs;
(function (NotarizedDocs) {
    function Default() {
        return {
            url: '',
            ref: '',
            userID: '',
            approvalStatus: 'pending'
        };
    }
    NotarizedDocs.Default = Default;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return Default();
        }
    }
    NotarizedDocs.CollectionClass = CollectionClass;
    NotarizedDocs.Collection = new CollectionClass({ path: '/NotarizedDocs' });
})(NotarizedDocs || (NotarizedDocs = {}));
//# sourceMappingURL=index.js.map